module.exports = __webpack_public_path__ + "static/k-delights-menu-ce257183bf0c75382eb9498dd0e6704b.jpg";